import React from 'react'
import { useTranslation } from 'react-i18next';
const LicenseBar = ({typeLicense, licenseDays}) => {
    const [t] = useTranslation('global');
    
    return (
        <>
            <span className="px-1 font-bold">{t("LicenseBar.warning")} :</span>
            {
                typeLicense === 'Trail' ?
                <span>{t("LicenseBar.trialVersion")} </span> :
                <span>{t("LicenseBar.version")} </span>
            }
            <span className='px-1 font-bold'>{licenseDays}</span>
            <span>{t("LicenseBar.days")}</span>
        </>
    )
}

export default LicenseBar